import React, { FunctionComponent, useEffect } from 'react';

import clsx from 'clsx';

import { Product } from '@domains/product';

import { sendShowProductsEvent } from '@utils/analytics';

import { useEmbla } from '@hooks/use-embla';

import { Container } from '@components/common/Container/Container';
import { SliderBlockTitle } from '@components/common/SliderBlockTitle/SliderBlockTitle';
import { SliderNavigation } from '@components/common/SliderNavigation/SliderNavigation';

import styles from './ProductsSlider.module.scss';

import { ProductCard } from '../ProductCard/ProductCard';

type ProductsSliderProps = {
    products: Product[];
    title?: string;
    className?: string;
};
export const ProductsSlider: FunctionComponent<ProductsSliderProps> = (props) => {
    const { products, className, title = 'Популярное' } = props;

    const { scrollPrev, scrollNext, isPrevButtonEnabled, isNextButtonEnabled, viewportRef } =
        useEmbla({
            loop: false,
            startIndex: 0,
            speed: 5,
            slidesToScroll: 1,
            dragFree: true,
            containScroll: 'trimSnaps',
            align: 'start',
        });

    useEffect(() => {
        if (products.length === 0) return;
        sendShowProductsEvent(products);
    }, [products]);

    return (
        <div className={clsx(styles.root, className)}>
            <SliderBlockTitle title={title} />

            <Container classes={{ root: styles.container }}>
                <div className={styles.slider}>
                    <div ref={viewportRef} className={styles.viewport}>
                        <div className={styles.sliderContainer}>
                            {products.map((product) => (
                                <div key={product.id} className={styles.slide}>
                                    <ProductCard product={product} className={styles.product} />
                                </div>
                            ))}
                        </div>
                    </div>

                    <SliderNavigation
                        onPrev={scrollPrev}
                        onNext={scrollNext}
                        isPrevButtonEnabled={isPrevButtonEnabled}
                        isNextButtonEnabled={isNextButtonEnabled}
                        variation="circle"
                        classes={{ button: styles.navigationButton }}
                    />
                </div>
            </Container>
        </div>
    );
};
